import React from 'react';
import { PaymentsProcessor } from '@weave/schema-gen-ts/dist/schemas/payments-platform/payments-config/payments_config.pb';
import { useMerchant } from '../use-merchant.hook';
import {
  ActiveMerchantInfo,
  ActiveMerchantInfoProps,
} from './active-merchant-info.component';
import { useSelector } from 'react-redux';
import { selectCurrentLocationId } from 'redux/actions/location';
import { useGetJustifiMerchantData, useGetSubAccountSettings } from 'apis/payments';

export const ActiveMerchantInfoJustifi = ({
  SunbitStatus,
  showTitle = false,
}: Pick<ActiveMerchantInfoProps, 'SunbitStatus'> & { showTitle?: boolean }) => {
  const locationId = useSelector(selectCurrentLocationId);
  const { payments, payouts } = useGetSubAccountSettings(locationId);
  const { subAccountId, businessId } = useGetJustifiMerchantData({ locationId });

  const achPaymentsEnabled = !!payments?.achPaymentsEnabled;
  const cardPresentEnabled = !!payments?.cardPresentEnabled;
  const creditCardPaymentsEnabled = !!payments?.creditCardPaymentsEnabled;

  return (
    <ActiveMerchantInfo
      title={showTitle ? 'JustiFi Merchant Account' : undefined}
      processorType={PaymentsProcessor.PAYMENTS_PROCESSOR_JUSTIFI}
      SunbitStatus={SunbitStatus}
      accountId={subAccountId}
      accountType={businessId}
      statusList={[
        { feature: 'ACH Payments', enabled: achPaymentsEnabled },
        { feature: 'Terminal Payments', enabled: cardPresentEnabled },
        { feature: 'Card Not Present', enabled: creditCardPaymentsEnabled },
        { feature: 'Payouts', enabled: payouts?.enabled },
      ]}
    />
  );
};
